import React, { useState, useEffect } from "react";

const DataTable = () => {
  const [users, setUsers] = useState([]);

  const f = async () => {
    const res = await fetch("https://reqres.in/api/users/");
    const json = await res.json();
    setUsers(json.data);
  };

  useEffect(() => {
    f();
  }, []);

  const handleDelete = (e, id) => {
    const newUser = [...users];
    const index = users.findIndex((el) => el.id !== id);
    newUser.splice(index, 1);
    setUsers(newUser);
  };
  return (
    <div className="App">
      <h1>User Team</h1>
      <div
        style={{
          maxWidth: "800px",
          border: "2px solid black",
          margin: "0 auto",
          height: "50vh",
          marginTop: "90px"
        }}
      >
        <table style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr style={{ borderBottom: "2px solid grey", padding: "20px" }}>
              <th style={{ padding: "10px", textAlign: "left" }}>First Name</th>
              <th style={{ padding: "10px", textAlign: "left" }}>Last Name</th>
            </tr>
          </thead>
          <tbody className="flex">
            {users.map((user) => {
              return (
                <tr key={user.id}>
                  <td style={{ padding: "10px", textAlign: "left" }}>
                    {user.first_name}
                  </td>
                  <td style={{ padding: "10px", textAlign: "left" }}>
                    {user.last_name}
                  </td>
                  <td
                    className=" px-3 py-1 text-red-400"
                    onClick={() => handleDelete(user.id)}
                  >
                    <i className="fas fa-trash-alt"></i>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;
